import { render } from "./OfferForm.vue?vue&type=template&id=6bf1460d&scoped=true"
import script from "./OfferForm.vue?vue&type=script&lang=js"
export * from "./OfferForm.vue?vue&type=script&lang=js"

import "./OfferForm.vue?vue&type=style&index=0&id=6bf1460d&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf1460d"]])

export default __exports__